




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GStudentRecordValueCell',
  computed: {},
  methods: {},
})
export default class GStudentRecordValueCell extends Vue {
  mounted() {}
}
